export const ANALYTICS_TABS = [
  { value: "overview", labelKey: "tabs.overview" },
  { value: "revenue", labelKey: "tabs.revenue" },
  { value: "services", labelKey: "tabs.services" },
  { value: "offers", labelKey: "tabs.offers" },
  { value: "reviews", labelKey: "tabs.reviews" },
  { value: "operations", labelKey: "tabs.operations" },
  { value: "team", labelKey: "tabs.team" },
] as const;

export type AnalyticsTab = (typeof ANALYTICS_TABS)[number]["value"];

export const DEFAULT_ANALYTICS_TAB: AnalyticsTab = "overview";

export function isAnalyticsTab(value: string): value is AnalyticsTab {
  return ANALYTICS_TABS.some((tab) => tab.value === value);
}
